import DOMPurify from "dompurify";

const cleverReachForm = document.getElementById("clevereachForm");

if (cleverReachForm) {
    const submit = cleverReachForm.getElementsByTagName("button")[0];
    const messageContainer = cleverReachForm.querySelector(".cleverreach__errors");

    submit.addEventListener("click", () => {

        if(!cleverReachForm.checkValidity()) {
            cleverReachForm.reportValidity();
            return;
        }

        submit.setAttribute("disabled", "true");

        const data = new FormData(cleverReachForm);

        fetch(cleverReachForm.getAttribute("action"), {
            method: "post",
            body: data,
        })
            .then((response) => response.json())
            .then((response) => {
                const message = document.createElement("span");
                message.innerHTML = DOMPurify.sanitize(response.message);
                if (!response.success) {
                    message.classList.add("text-red");
                }
                messageContainer.appendChild(message);
            })
            .catch((error) => console.log(error.message));
    });

    submit.removeAttribute("disabled");
}
